module.exports = "/**\n* @ORM\\OneToMany(targetEntity=\"Ticket\", mappedBy=\"movie\")\n*/\nprivate $tickets;\n\npublic function __construct()\n{\n    $this->actors = new ArrayCollection();\n    $this->tickets = new ArrayCollection();\n}\n\npublic function getTickets()\n{\n    return $this->tickets;\n}\n\npublic function addTicket(Ticket $ticket)\n{\n    $this->tickets[] = $ticket;\n\n    return $this;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/entity-movie.txt
// module id = 640
// module chunks = 271754190448615